import { FormatsService } from '../formats.service';
import { Default, TechFormatNumer, TechGetDecimalInfo, Utils } from '../utils';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';

@Pipe({
  name: 'trCurrencySignus',
})
@Injectable({ providedIn: 'root' })
export class CurrencySignusPipe implements PipeTransform {
  constructor(private formats: FormatsService) {}

  transform(value: number, currencyCode: string, digitsInfo?: string): string {
    if (!Utils.isValue(value)) return null;

    digitsInfo = Utils.isValue(digitsInfo) ? digitsInfo : Default.digitsInfo;

    const locale: string = this.formats.locale;
    const currencySymbol = Utils.checkCustomCurrencySymbol(
      currencyCode,
      this.formats.customCurrencySymbols
    );

    //let num = formatNumber(value, locale, digitsInfo);

    const curr = getCurrencySymbol(currencyCode, 'narrow');

    const decimalPlaces = TechGetDecimalInfo(digitsInfo);

    // Redondear el número a la cantidad deseada de decimales
    const roundedNumber = value.toFixed(decimalPlaces);

    let num = TechFormatNumer(
      roundedNumber,
      this.formats.decimalCharacter,
      this.formats.digitGroupSeparator
    );

    if (Utils.isValue(this.formats.customCurrencyPosition)) {
      if (value > 0) {
        num = '+' + num;
      }
      const txt = Default.templateInfo;
      if (this.formats.customCurrencyPosition === 'L') {
        return Utils.formatString(txt, [currencySymbol, num]);
      } else if (this.formats.customCurrencyPosition === 'R') {
        return Utils.formatString(txt, [num, currencySymbol]);
      }
    } else {
      /*
      let num2 = formatCurrency(
        value,
        locale,
        currencySymbol,
        currencyCode,
        digitsInfo
      );

      */

      const txt = '{0} {1}';
      if (value > 0) {
        num = '+' + num;
        // num2 = num2.replace(num, num);
      }
      let num2 = Utils.formatString(txt, [num, curr]);


      return num2;
    }
  }
}
